import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL + 'api/public/';
export const IMG_URL = process.env.REACT_APP_IMG_URL + 'uploads/artbanne/';

const TENANT = 'artbanne';

const apiClient = axios.create({
    baseURL: API_URL,
    headers: {
        'x-tenant': TENANT
    }
});

export const Systempay = {
    createPayment: async function (data) {
        try {
            return await apiClient.post('systempay/createPayment/', { data });
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
};

export default Systempay;